module.exports = __webpack_public_path__ + "img/PatientXChange_Logo.b1d50e18.svg";